




import { Vue, Component } from 'vue-property-decorator';
import EnterpriseBrandAudit from '@/views/brand-audit/Index.vue';

// 企业首页(非平台)
@Component({
  components: { EnterpriseBrandAudit },
})
export default class EnterpriseHome extends Vue {
}
